export * from './custom-icons.module';
